import React, { Component } from 'react';
import RecoveryNotificationUi from '../../../presentationals/Admin/Recovery/RecoveryNotification.component';
import Popup from '../../../presentationals/Popup/Popup.component';
import { sendRecoveryNotificationAPI } from '../AdminActionCreator.component'

class RecoveryNotificationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupState: false,
            popupStatus: '',
            subject: '',
        }
    }

    componentWillMount() {

    }

    render() {
        const { duePayment, admin } = this.props;
        return (
            <div className="full-height">
                {this.state.popupState == true ?
                    <Popup
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                    : ""}
                <RecoveryNotificationUi
                    recoveryNotificationChange={this.recoveryNotificationChange.bind(this)}
                    recoveryNotificationHandler={this.recoveryNotificationHandler.bind(this)}
                />
            </div>
        )
    }

    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }

    closePopup() {
        this.setState({ popupState: false });
    }


    recoveryNotificationChange(e, NotificationType) {
        if (NotificationType == 'subject') {
            this.setState({ subject: e.target.value })
        }
    }

    recoveryNotificationHandler() {
        const { dataForCommunication, admin } = this.props;
        var notificationBody = document.getElementById("recoveryNotificationBody").innerHTML
        if (this.state.subject != '') {
            sendRecoveryNotificationAPI(this.state.subject, dataForCommunication, notificationBody, admin,'',
                (callBack) => {
                    if (callBack == 'success') {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Notification Sent Successfully',
                        })
                        this.removePopup();
                    } else {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Please Try Again',
                        })
                        this.removePopup();
                    }
                })
        } else {
            this.setState({
                popupState: true,
                popupStatus: 'Please Type Subject and Body first',
            })
            this.removePopup();
        }
    }

}

export default RecoveryNotificationPage;